export enum FileUploadPermission {
  CHOOSE_FROM_DEVICE = "CHOOSE_FROM_DEVICE",
  choose_from_device = "choose_from_device",
  camera = "camera"
}
